import {filtersStore} from "./filters";

export const itemsStore = {
    namespaced: true,
    state() {
        return {
            totalPublishedDevelopments: 0,
            currentPage: 1,
            findItems: 0,
            newItems: [],
            popularItems: [],
            lastPage: 3,
            items: [],
            detailItem: {
                "id": "01h9tcqsa2e63ab8hr3es41gr6",
                "title": "Фонетические ошибки в речи детей мигрантов с позиции этнокогнитивного подхода к обучению русскому языку",
                "title_image_storage": null,
                "title_image_path": null,
                "description": "Статья содержит анализ фонетических ошибок в речи тюркоязычных школьников, обучающихся в полиэтнических классах и на дополнительных корректировочных курсах Санкт-Петербурга и Ленинградской области. Автором были выделены и описаны типичные фонетические ошибки, свойственные тюркоязычным обучающимся. В качестве причин большого количества фонетических ошибок в речи учащихся-инофонов автор называет отсутствие специальных учебных пособий по фонетике русского языка для тюркоязычных школьников и игнорирование учителями результатов контрастивных лингвистических исследований в области фонетики. Более того, за время наблюдения за школьниками-инофонами не было зафиксировано целенаправленной работы с ними над звукопроизношением. Автор обосновывает необходимость целенаправленной когнитивно ориентированной работы над произношением на протяжении всего обучения русскому языку как неродному и дает практические рекомендации для корректировки произношения тюркоязычных школьников, касающиеся необходимости включать пары слов с твёрдыми / мягкими согласными, со стечением согласных / с открытыми слогами, с ударными / редуцированными гласными и систематической корректировки прочих отклонений от произносительной нормы.",
                "state": "published",
                "created_at": "2023-09-08T12:37:14.000000Z",
                "published_at": "2023-09-08T12:37:14.000000Z",
                "title_image_url": null,
                "authors": [],
                "type": {
                    "id": "01h6rhwdttzdz6b38mfaqgcbha",
                    "label": "результаты научных исследований",
                    "meta": null
                },
                "rubrics": [
                    {
                        "id": "01h6rhwe9pcrch6fpnn6923b1d",
                        "label": "Справочник научно-методических разработок",
                        "order": 0,
                        "meta": {
                            "cv": true,
                            "allow_data_file": true,
                            "need_directions": true
                        },
                        "created_at": "2023-08-01T12:41:35.000000Z",
                        "published_at": "2023-09-06T14:51:00.000000Z",
                        "pivot": {
                            "publication_id": "01h9tcqsa2e63ab8hr3es41gr6",
                            "rubric_id": "01h6rhwe9pcrch6fpnn6923b1d"
                        }
                    }
                ],
                "directions": [
                    {
                        "id": "01h6rhwentjgm50j6rtej060cb",
                        "label": "технологии формирования управленческих компетенций руководителей образовательных организаций",
                        "meta": null
                    }
                ],
                "education_subjects": [],
                "education_grade": null,
                "tags": [
                    {
                        "id": "01h9ta2pxqcqae9pk9q843qt3e",
                        "value": "kliucevye_slova"
                    },
                    {
                        "id": "01h9ta2pyvce6bn5h7vppn3y40",
                        "value": "4"
                    },
                    {
                        "id": "01h9ta2q0vzvpc5vtakvtcxckg",
                        "value": "5"
                    },
                    {
                        "id": "01h9ta2q4x0346fega8z2w6ra8",
                        "value": "6"
                    },
                    {
                        "id": "01h9ta2q6czq62kmy180ra3qch",
                        "value": "7"
                    },
                    {
                        "id": "01h9ta2q8028bewzt2cvxtn7mt",
                        "value": "8"
                    },
                    {
                        "id": "01h9ta2qe7jbkzfw2hqng7wzxt",
                        "value": "9"
                    }
                ],
                "data": {
                    "id": "01h9tcqsq9pc3zt06efrv4kc95",
                    "publication_id": "01h9tcqsa2e63ab8hr3es41gr6",
                    "storage": "url",
                    "path": "https://cyberleninka.ru/article/n/foneticheskie-oshibki-v-rechi-detey-migrantov-s-pozitsii-etnokognitivnogo-podhoda-k-obucheniyu-russkomu-yazyku",
                    "description": "Железнякова Е.А. Фонетические ошибки в речи детей мигрантов с позиции этнокогнитивного подхода к обучению русскому языку // МИРС. 2020. № 4. С. 111-116. URL: https://cyberleninka.ru/article/n/foneticheskie-oshibki-v-rechi-detey-migrantov-s-pozitsii-etnokognitivnogo-podhoda-k-obucheniyu-russkomu-yazyku (дата обращения: 06.07.2022).",
                    "paid": null,
                    "created_at": "2023-09-08T12:37:14.000000Z",
                    "published_at": "2023-09-08T12:37:14.000000Z",
                    "url": "https://cyberleninka.ru/article/n/foneticheskie-oshibki-v-rechi-detey-migrantov-s-pozitsii-etnokognitivnogo-podhoda-k-obucheniyu-russkomu-yazyku"
                },
                "owner_team": {
                    "id": "01h9t4mm4tk6e3sdw359g2e16v",
                    "name": "ФГАОУ ДПО «Академия Минпросвещения России»",
                    "logo_url": "https://storage.yandexcloud.net/navigator-data/01h9t4mm4tk6e3sdw359g2e16v/P3Hl9pn6emhogHXLiLhnLB3T69rnKMq5x0q7wL5b.svg"
                },
                "owner_user": {
                    "id": "01h9t9njye62s8aqmxfs1b1bk3",
                    "name": "Составитель Академия Минпросвещения"
                }
            }
        }
    },
    actions: {
        async getItems({ dispatch, commit, rootState }): void {
            let filters = [];

            for (var key in rootState.filtersStore) {
                if(key === 'filterItems') continue;

                if (typeof rootState.filtersStore[key] === 'object') {
                    if(rootState.filtersStore[key].length > 0) {
                        filters[key] = rootState.filtersStore[key][0];
                    }
                }
            }

            let query = {
                page: rootState.itemsStore.currentPage,
                'with[]': ['ownerTeam','type','rubrics','directions','data:publication_id,paid','educationSubjects'],
                filters: filters,
            };

            await commit('getData',{
                url: 'https://navigator.apkpro.ru/api/publications/',
                firstQuery: true,
                query: query,
            });
        },
        addCurrentPage(store): void {
            store.commit('addCurrentPage');
        },
        sendFilters: ({ commit, rootState }) => {
            let filters = [];

            commit('resetCurrentPage');
            for (var key in rootState.filtersStore) {
                if(key === 'filterItems') continue;

                if (typeof rootState.filtersStore[key] === 'object') {
                    if(rootState.filtersStore[key].length > 0) {
                        filters[key] = rootState.filtersStore[key][0];
                    }
                    if(key == 'published_at') {
                        if(Object.keys(rootState.filtersStore[key]).length > 0) {
                            filters[key] = rootState.filtersStore[key]
                        }
                    }
                }
                if (typeof rootState.filtersStore[key] === 'string') {

                }
            }
            let query = {
                page: rootState.itemsStore.currentPage,
                'with[]': ['ownerTeam','type','rubrics','directions','data:publication_id,paid','educationSubjects'],
                filters: filters,
            };

            if(!!rootState.filtersStore.search) {
                if(rootState.filtersStore.search[0] !== '') {
                    query['search'] = rootState.filtersStore.search[0];
                }
            }

            commit('getData',{
                url: 'https://navigator.apkpro.ru/api/publications/',
                query: query,
            });
        },
        getDetailInfo({commit}, payload) {
            commit('getSingleData', {
                url: 'https://navigator.apkpro.ru/api/publications/'+payload
            })
        },
        getNewItems: ({ commit, rootState }) => {
            let query = {
                page: rootState.itemsStore.currentPage,
                'with[]': ['ownerTeam','type','rubrics','directions','data:publication_id,paid','educationSubjects'],
            };

            commit('getData',{
                url: 'https://navigator.apkpro.ru/api/publications/',
                firstQuery: true,
                type: 'new',
                query: query,
            });
        },
        getPopularItems: ({ commit, rootState }) => {
            let query = {
                page: rootState.itemsStore.currentPage,
                'with[]': ['ownerTeam','type','rubrics','directions','data:publication_id,paid','educationSubjects'],
                sortBy: 'loading_count',
            };

            commit('getData',{
                url: 'https://navigator.apkpro.ru/api/publications/',
                firstQuery: true,
                type: 'popular',
                query: query,
            });
        }
    },
    mutations: {
        getData: (state, payload = {}) => {
            let url = new URL(payload.url);
            for (var key in payload.query) {
                if(Array.isArray(payload.query[key])) {
                    if(key === 'filters') {
                        for (var keyIn in payload.query[key]) {
                            if(Array.isArray(payload.query[key][keyIn])) {
                                if(keyIn == 'published_at') {
                                    url.searchParams.append(`filters[${keyIn}][from]`, payload.query[key][keyIn]['from'])
                                    url.searchParams.append(`filters[${keyIn}][to]`, payload.query[key][keyIn]['to'])
                                } else {
                                    payload.query[key][keyIn].forEach(function (item1, index1, array) {
                                        url.searchParams.append(`filters[${keyIn}][${index1}]`, item1)
                                    });
                                }
                            } else {
                                console.log(2);
                                url.searchParams.append(`filters[${keyIn}]`, payload.query[key][keyIn])
                            }
                        }
                    } else {
                        payload.query[key].forEach(function (item, index, array) {
                            url.searchParams.append(key, item)
                        });
                    }
                } else {
                    url.searchParams.set(key, payload.query[key])
                }
            }
            fetch(url)
                .then(response => response.json())
                .then(data => {
                    if(payload.type === 'popular') {
                        state.popularItems = data.data;
                    } else if(payload.type === 'new') {
                        state.newItems = data.data;
                    } else {
                        if(payload.query.page === 1) {
                            state.items = [];
                        }
                        state.items = [...state.items, ...data.data];
                        state.lastPage = data.last_page;
                        if (payload.firstQuery) {
                            state.totalPublishedDevelopments = data.total;
                        }
                    }
                });
        },
        getSingleData: (state, payload = {}) => {

            let url = new URL(payload.url);
            fetch(url)
                .then(response => response.json())
                .then(data => {
                    state.detailItem = data;
                });
        },
        addCurrentPage: (state) => {
            state.currentPage++;
        },
        resetCurrentPage: (state) => {
            state.currentPage = 1;
        },
        sendFilters: (state) => {
            console.log('sendFilters')
        }
    },
    getters: {
        newItems: state => {
            return state.newItems.slice(0, 15);
        },
        popularItems: state => {
            let arr = [];
            state.popularItems.forEach(function (value, index){
                if(index <= 15) {
                    arr.push(value);
                }
            })
            return arr //state.popularItems.splice(15, 1);
        },
    }
}